import { render, staticRenderFns } from "./PuMain.vue?vue&type=template&id=06070982&scoped=true&"
import script from "./PuMain.vue?vue&type=script&lang=js&"
export * from "./PuMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06070982",
  null
  
)

export default component.exports